exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HistorySingleScreen .transactionWrap .transactionRow {\n  display: flex; }\n  .HistorySingleScreen .transactionWrap .transactionRow .transactionColLeft {\n    display: inline-block;\n    width: 30%;\n    min-width: 78px;\n    margin-right: 15px;\n    border-right: 1px solid #939393;\n    padding: 5px; }\n  .HistorySingleScreen .transactionWrap .transactionRow .transactionColRight {\n    display: inline-block;\n    width: 70%;\n    padding: 5px; }\n\n.HistorySingleScreen .Badge {\n  float: none;\n  display: inline-block; }\n\n.HistorySingleScreen .Button {\n  float: right; }\n", ""]);

// exports
